import { useStorageUrl } from '../hooks/useStorageUrl';

export const useFormatImageUrl = () => {
  const { storageUrl } = useStorageUrl();

  return (imagePath?: string): string => {
    if (!imagePath) return '';

    // Normalize storage URL without trailing slash
    const normalizedStorageUrl = storageUrl?.replace(/\/$/, '') || '';

    // Check if imagePath starts with normalized storage URL (case insensitive)
    if (normalizedStorageUrl && new RegExp(`^${normalizedStorageUrl}/?`, 'i').test(imagePath)) {
      return imagePath;
    }

    // Local URL check - we don't want to format localhost URLs
    if (imagePath.startsWith('http://localhost') || imagePath.startsWith('https://localhost')) {
      return imagePath;
    }

    // Extract just the file path if we have a full URL from other domains
    let filePath = imagePath;
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
      const url = new URL(imagePath);
      filePath = url.pathname.substring(1); // Remove leading slash
    }

    // Handle relative paths starting with slash
    else if (imagePath.startsWith('/')) {
      filePath = imagePath.substring(1); // Remove leading slash
    }

    // If imagePath is just a filename without a URL (e.g., 'image.jpg')
    else if (!imagePath.includes('/')) {
      filePath = imagePath;
    }

    return storageUrl ? `${storageUrl}/${filePath}` : filePath;
  };
};
